import React from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  VStack, Heading, Text, Button, List, ListItem, ListIcon, HStack
} from '@chakra-ui/react';
import { CheckCircleIcon, StarIcon } from '@chakra-ui/icons';
import API_URL from '../config';
import toastService from '../utils/toastService';

const UpgradeModal = ({ isOpen, onClose, username, reason }) => {
  const [loading, setLoading] = React.useState(false);

  const handleUpgrade = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/create_checkout_session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username })
      });

      const data = await response.json();

      if (data.success && data.result.checkout_url) {
        // Redirect to Stripe Checkout
        window.location.href = data.result.checkout_url;
      } else {
        toastService.error('Error', data.message);
        setLoading(false);
      }
    } catch (error) {
      toastService.networkError('Request Failed', 'Please try again.');
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <StarIcon color="purple.500" />
            <Heading size="lg">Upgrade to Grow Pro</Heading>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={6} align="stretch">
            {reason && (
              <Text color="gray.600" fontSize="md">
                {reason}
              </Text>
            )}

            <VStack spacing={4} align="stretch" bg="purple.50" p={6} borderRadius="lg">
              <Heading size="md" color="purple.700">What's included:</Heading>
              <List spacing={3}>
                <ListItem>
                  <HStack>
                    <ListIcon as={CheckCircleIcon} color="purple.500" />
                    <Text>Unlimited goals and exercises</Text>
                  </HStack>
                </ListItem>
                <ListItem>
                  <HStack>
                    <ListIcon as={CheckCircleIcon} color="purple.500" />
                    <Text>7-day free trial</Text>
                  </HStack>
                </ListItem>
                <ListItem>
                  <HStack>
                    <ListIcon as={CheckCircleIcon} color="purple.500" />
                    <Text>Priority AI generation</Text>
                  </HStack>
                </ListItem>
                <ListItem>
                  <HStack>
                    <ListIcon as={CheckCircleIcon} color="purple.500" />
                    <Text>Cancel anytime</Text>
                  </HStack>
                </ListItem>
              </List>
            </VStack>

            <VStack spacing={3}>
              <HStack>
                <Heading size="2xl" color="purple.600">$9.99</Heading>
                <Text color="gray.600">/month</Text>
              </HStack>
              <Button
                size="lg"
                colorScheme="purple"
                w="full"
                onClick={handleUpgrade}
                isLoading={loading}
              >
                Start Free Trial
              </Button>
              <Button
                size="md"
                variant="ghost"
                w="full"
                onClick={onClose}
              >
                Maybe Later
              </Button>
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default UpgradeModal;
